import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { StorageService } from './storage.service';
import { transformAll } from '@angular/compiler/src/render3/r3_ast';

@Injectable({
  providedIn: 'root'
})
export class RmsService {

  private static SERVER: string = location.protocol + '//api.ahacafe.vn';

  public loggedIn = new EventEmitter();
  public loggedOut = new EventEmitter();

  constructor(
      private http: HttpClient,
      private storage: StorageService
  ) { }

  public get isLoggedIn(): boolean {
    return this.getToken() != null;
  }

  public post<TRequest, TResponse>(service, request: TRequest): Observable<TResponse> {

    let uri = RmsService.SERVER + "/" + service;

    return this.http.post(uri, JSON.stringify(request)).pipe<TResponse>(map((response: TResponse) => response));
  }

  public get<TResponse>(service): Observable<TResponse> {

    let uri = RmsService.SERVER + "/" + service;

    return this.http.get(uri).pipe<TResponse>(map((response: TResponse) => response));
  }

  public request<TRequest, TResponse>(request: RmsRequest<TRequest>): Observable<RmsResponse<TResponse>> {

    let payload = {
      CredentialID: this.getToken(),
      CredentialType: 3,
      Data: request.data
    };

    let uri = RmsService.SERVER + "/" + request.service;

    return this.http.post(uri, JSON.stringify(payload)).pipe<RmsResponse<TResponse>>(map((response: RawRmsResponse<TResponse>) => {
      if (response != null && response.Result == RMSRequestResult.invalidCredential) {
        this.logout();
      }

      return {
        succeed: response != null && response.Result == RMSRequestResult.ok,
        data: response != null ? response.Data : null
      }
    }));
  }

  public login(username: string, password: string): Observable<boolean> {

    return this.request<{ Username: string, Password: string, Type: number }, { Result: LoginResult, CredentialID: string }>({
      service: 'RMS:Login',
      data: {
        Username: username,
        Password: password,
        Type: 3
      }
    }).pipe((map((response) => {

      let result = response != null
          && response.succeed
          && response.data.Result == LoginResult.succeed;
      this.setToken(response.data.CredentialID);
      if (result) this.loggedIn.emit();

      return result;
    })));
  }
  public pomDataUser(){
    return this.request({service: 'pom.data.user', data: this.getToken()});
  }

  setUser(data){
    this.storage.set('userData', data);
  }
  getUser(){
    return this.storage.get('userData');
  }
  public logout(): boolean {
    this.setToken(null);
    this.loggedOut.emit();
    return true;
  }

  setCookie(cname, cvalue, exdays = 30) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + JSON.stringify(cvalue) + ";domain=ahacafe.vn;"+ expires + ";path=/";
  }
  setToken(token){
    this.storage.set('a2Token',token);
    this.setCookie('a2Token',token);
  }
  getToken(){
    return this.getCookie('a2Token') ||this.storage.get('a2Token');
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        let rs = c.substring(name.length, c.length);
        return JSON.parse(rs);
      }
    }
    return null;
  }
}

interface RawRmsResponse<T> {
  Result: RMSRequestResult;
  Data: T;
}

enum RMSRequestResult {
  unknown,
  notPermitted,
  invalidCredential,
  invalidRequest,
  ok
}

enum LoginResult {
  unknown,
  succeed,
  usernameError,
  passwordError,
  allocationError,
  invalidCredentialType,
  invalidCredential,
  requestFailed

}

export interface RmsRequest<T> {
  service: string;
  data: T;
}

export interface RmsResponse<T> {
  succeed: boolean;
  data: T;
}
